import { useEffect, useState } from 'react';
import axios from '../../api/axiosInstance';
import Loader from './components/Loader';

export default function NotificationsList({ businessId, onNavigate }) {
  const [notifs, setNotifs] = useState([]);
  const [state, setState] = useState('loading');

  useEffect(() => {
    setState('loading');
    axios
      .get('/dashboard/notifications', { params: { business_id: businessId } })
      .then(({ data }) => {
        setNotifs(data);
        setState('ready');
      })
      .catch(() => setState('error'));
  }, [businessId]);

  if (state === 'loading') return <Loader />;
  if (state === 'error') return <p className="text-sm text-gray-500 text-center">No notifications yet</p>;

  if (notifs.length === 0)
    return <p className="text-sm text-gray-500 text-center">No notifications yet</p>;

  return (
    <ul className="space-y-3">
      {notifs.slice(0, 10).map((n) => (
        <li key={n.id} className="flex items-start gap-2">
          <span className="text-lg">🔔</span>
          <button
            onClick={() => onNavigate(businessId)}
            className="text-left text-sm hover:underline"
          >
            {n.message}
          </button>
        </li>
      ))}
    </ul>
  );
}
